export function createPanelDetailSourceResolverService(deps) {
    // panel 表示元の行を解決し、早期 return 対象かどうかも返します。
    function resolvePanelDetailSourceRows(panelInfo, detailData, options = {}) {
        const buildContext = deps.normalizeFukushizaiContext(options.context ?? null);
        const previewOverride = options.previewOverride;
        const panelType = deps.getPanelType(panelInfo);

        // 副資材 shared context panel は item/group 未確定なら空表示にします。
        if (deps.isFukushizaiSharedContextPanelInfo(panelInfo) && !deps.hasCompleteFukushizaiContext(buildContext)) {
            return {
                handled: true,
                context: buildContext,
                rows: []
            };
        }

        // 副資材 context display panel は専用 service 側で代表行を組み立てます。
        if (deps.isFukushizaiContextDisplayPanelInfo(panelInfo)) {
            return {
                handled: true,
                context: buildContext,
                rows: deps.buildFukushizaiContextDisplayRows(
                    panelInfo,
                    detailData,
                    previewOverride,
                    buildContext
                )
            };
        }

        const rows = deps.pickDetailRows(detailData, panelInfo);

        // 表示元が見つからない場合は空配列として扱います。
        if (!Array.isArray(rows)) {
            return {
                handled: true,
                context: buildContext,
                rows: []
            };
        }

        return {
            handled: false,
            context: buildContext,
            rows
        };
    }

    return {
        resolvePanelDetailSourceRows
    };
}
